//@flow

import { useState } from 'react'

export const useWebcamPopup = () => {
  const [popupOpen, setPopupOpen] = useState(false)

  const closePopup = () => {
    setPopupOpen(false)
  }
  const openPopup = () => {
    setPopupOpen(true)
  }

  return { popupOpen, closePopup, openPopup }
}
